export default "__VITE_ASSET__c88326cb__"